import { Injectable } from '@angular/core';
import { HttpClient, HttpParams} from '@angular/common/http';
import { environment } from "../../environments/environment";
import { BBResponseContainer } from '../common-services/response-container';
import { timeout, tap} from 'rxjs/operators';
import { Observable } from 'rxjs';
import { MergeRequest } from './merge-request';
import { Covid19Batch } from '../agptesting-newview/model/covid19Batch';


@Injectable()
export class MidplexMergeService {
  defaultTimeout = 600000;
  
  
  constructor(private http: HttpClient) {
  }
  
  mergeBatch(mergeRequest: MergeRequest): Observable<any> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + 'midplex/merge';
    return this.http.post<BBResponseContainer>(url, mergeRequest).pipe(timeout(environment.defaultTimeout), tap(error => {
      error.url = url;
    }));
  }
  getBatches(selectedLabId: string, workflowGroup:string, mergeInStatus: string, selectedProductList: any[]): Observable<any> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "midplex/listOfEligibleBatches/" + selectedLabId +"/"+ workflowGroup +"/"+ mergeInStatus +"/"+ selectedProductList;
    return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
  }
  
  getAllMergedDefinedBatces(selectedLabId: string) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "midplex/listOfMergeBatches/Midplex/" + selectedLabId;
    return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
  }
  undoMerge(mergeRequest: MergeRequest): Observable<any> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + 'midplex/undoMerge/' + mergeRequest.labId;
    return this.http.patch<BBResponseContainer>(url, mergeRequest).pipe(timeout(environment.defaultTimeout), tap(error => {
      error.url = url;
    }));
  }
  
  defineMerge(mergeRequest: Covid19Batch): Observable<any> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + 'midplex/updateBatchStatus';
    return this.http.post<BBResponseContainer>(url, mergeRequest).pipe(timeout(environment.defaultTimeout), tap(error => {
      error.url = url;
    }));
  }
  completeMergeProcess(mergeSelectedBatch: Covid19Batch, selectedLabId: string): Observable<any>{
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + 'midplex/updateBatchStatus/' + selectedLabId;
    return this.http.patch<BBResponseContainer>(url, mergeSelectedBatch).pipe(timeout(environment.defaultTimeout), tap(error => {
      error.url = url;
    }));
  }

  getBatchForLabAndBatchId(labId: string, fieldName: string , value:string ): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch";
    let requestParam = new HttpParams().set('lab', labId).set('fieldName', fieldName).set('value', value);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
  }
}
